// extracted by mini-css-extract-plugin
export var clickableWrapper = "_25-2";
export var placeholderIcon = "_25-3";
export var thumbnailCanvas = "_25-1";
export var thumbnailWrapper = "_25-0";